module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-icons"
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, _vm._l((_vm.serviceAreas), function(serviceArea, index) {
    return (_vm.serviceRelationship[serviceArea.name]) ? _c('div', {
      staticClass: "layout__item desktop--fifth service-area",
      staticStyle: {
        "height": "25%"
      }
    }, [_c('div', {
      staticClass: "text--center"
    }, [_c('img', {
      staticClass: "service-icons__icon",
      attrs: {
        "src": serviceArea.imageOff
      }
    })])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-825ea1c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ServiceIcons/ServiceIcons.vue
// module id = 557
// module chunks = 1